<template>
    <div class="">
        <GmapMap
                ref="mapRef"
                :center="{lat:this.lat, lng:this.lng}"
                :zoom="zoom"
                map-type-id="terrain"
                style="width: 100%; height: 550px"
                :options="{
                  scrollwheel: false,
                  gestureHandling: 'greedy',
                  streetViewControl: true
                }"
        >
            <gmap-custom-marker v-for="(project, index) in projectList" :key="index"
              :marker="{lat:parseFloat(project.marker_lat), lng:parseFloat(project.marker_lng)}"
              @click.native="toggleInfoWindow(project, index)"
            >
              <span class="vue-map-marker-label">{{project.name}}</span>
            </gmap-custom-marker>
            <gmap-info-window
                    :options="infoOptions"
                    :position="infoWindowPos"
                    :opened="infoWinOpen"
                    @closeclick="infoWinOpen=false"
            >
                <project-item-maps ref="itemMap" :url-params="urlParams"></project-item-maps>
            </gmap-info-window>
        </GmapMap>
    </div>
</template>

<script>
  import ProjectItemMaps from "../../partials/ProjectItemMaps";
  import GmapCustomMarker from 'vue2-gmap-custom-marker';

  export default {
    name: 'ListProjectsMap',
    props: ['projects','urlParams'],
    components: {
      ProjectItemMaps,
      'gmap-custom-marker': GmapCustomMarker
    },
    computed: {
      projectList() {
        return this.projects.filter(project => {
          return project.marker_lat && project.marker_lng
        })
      }
    },
    data() {
      return {
        zoom: 9,
        lat: 44.439663,
        lng: 26.096306,
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        currentMidx: null,
        infoWinOpen: false,
        activeProject: null,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
      }
    },
    methods: {
      toggleInfoWindow: function (project, idx) {
        this.infoWindowPos = {
          lat: parseFloat(project.marker_lat),
          lng: parseFloat(project.marker_lng)
        };

        this.$refs.itemMap.project = project
        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      }
    },
    created() {

    }
  }
</script>
